export default [
  { path: 'fraud/opti/bin', component: () => import('./pages/OptiReports.vue') },
  { path: 'fraud/opti/affiliates', component: () => import('./pages/OptiReports.vue') }
]
